module.exports = __webpack_public_path__ + "img/zc-10.c26ac2c4.svg";